import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

import { shopdata } from "../../assets/Griddata"; // Import dataset
import { SHOP_API_01 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

function ViewMapUsers() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [data, setData] = useState(null);

  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, USERNAME, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  const goToPage = () => {
    navigate("/AddShop");
  };

  // useEffect(() => {
  //   if (data) {
  //     const filtered = data.filter((item) =>
  //       item.RESTCODE.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //     setFilteredData(filtered);
  //   }
  // }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

  const handleItemClick = (id, actionText) => {
    if (actionText == "Edit") {
      const selectedItem = data.find((item) => item.RESTCODE == id);
      if (selectedItem) {
        navigate(`/AddShop`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/AddShop`, { state: { selectedItem: "" } });
    }
  };
  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (RESTCODE) => handleItemClick(RESTCODE, "Edit"),
    },
  ];

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        RESTCODE: item.RESTCODE,
        DESCRIPTION: item.DESCRIPTION,
        STORE: item.STORE,
        ADDRESS: item.ADDRESS,
        HOTLINE: item.HOTLINE,
        FAX: item.FAX,
        EMAIL: item.EMAIL,
      }))
    : [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SHOP_API_01, "get", {
          COMPCODE: COMPCODE,
          GROUPCODE: GROUPCODE,
          USERNAME: USERNAME,
          // CATTYPE: "R",
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setFilteredData(result);
        console.log("result shop", result);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                {/* <Link underline="none">Shop</Link> */}
                <Link underline="none">View Map Users</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                  id="search"
                />
                <Button
                  onClick={goToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    width: "80px",
                  }}
                  id="btnadd"
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={shopdata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={shopdata.name}
          gridid="RESTCODE"
        />
      )}
    </div>
  );
}

export default ViewMapUsers;
